import { countryCodes } from './countries';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import compose from 'lodash/fp/compose';

/**
 * This function return the translated dictionary, the result
 * dependes if it should be plural or singular
 * singular means that the passed number value is equal to 1, so if
 * the number is equal to 1 the function will return the singular translated of
 * the dictionary key
 * @param  {number} Object.quantity number of solutions
 * @param  {string} Object.dictionary solution Label to be translated
 * @param  {Object} Object.sitecoreContext this object value is injected through the HOC withSitecoreContext
 * @param  {function} Object.t this function is injected through the HOC withNamespaces
 * @returns {React.Node}
 */
const applyPluralRule = ({ sitecoreContext, quantity, dictionary, t }) => {
  const { language } = sitecoreContext;
  const languageIsoCode = language.toLowerCase().slice(0, 2);

  if (!quantity && !dictionary && !language) return dictionary;

  const isAPluralLanguage = countryCodes.some(
    value => languageIsoCode === value,
  );
  const isSingular = quantity === 1;

  if (isAPluralLanguage && isSingular) {
    return t(`${dictionary}_singular`);
  }

  return t(dictionary);
};

export default compose(
  withSitecoreContext(),
  withNamespaces(),
)(applyPluralRule);
